import React, { useEffect } from 'react';
import { HashRouter as Router, Routes, Route, useLocation } from 'react-router-dom';
import { motion, AnimatePresence } from 'framer-motion';
import Navbar from './components/Navbar';
import Footer from './components/Footer';
import Home from './pages/Home';
import Services from './pages/Services';
import Gallery from './pages/Gallery';
import About from './pages/About';
import Contact from './pages/Contact';
import ScrollToTop from './components/ScrollToTop';
import './App.css';

// Wrapper component to handle scroll to top
function ScrollToTopWrapper() {
  const location = useLocation();
  
  useEffect(() => {
    // Force scroll to top when route changes
    const scrollToTop = () => {
      window.scrollTo(0, 0);
      document.documentElement.scrollTop = 0;
      document.body.scrollTop = 0;
      if (window.scrollY > 0) {
        window.scrollTo(0, 0);
      }
    };
    
    // Immediate scroll
    scrollToTop();
    
    // Multiple attempts to ensure scroll to top
    const timers = [
      setTimeout(scrollToTop, 0),
      setTimeout(scrollToTop, 50),
      setTimeout(scrollToTop, 100),
      setTimeout(scrollToTop, 200)
    ];
    
    // Also force scroll on hash change
    const handleHashChange = () => {
      scrollToTop();
    };
    
    window.addEventListener('hashchange', handleHashChange);
    
    return () => {
      timers.forEach(timer => clearTimeout(timer));
      window.removeEventListener('hashchange', handleHashChange);
    };
  }, [location.pathname]);
  
  return null;
}

function App() {
  return (
    <Router>
      <div className="min-h-screen bg-white">
        <ScrollToTopWrapper />
        <Navbar />
        <AnimatePresence mode="wait">
          <Routes>
            <Route path="/" element={<Home />} />
            <Route path="/services" element={<Services />} />
            <Route path="/gallery" element={<Gallery />} />
            <Route path="/about" element={<About />} />
            <Route path="/contact" element={<Contact />} />
          </Routes>
        </AnimatePresence>
        <Footer />
      </div>
    </Router>
  );
}

export default App;